import { StateCreator } from 'zustand'
import { logger, enqueueLoadedSnackbar, exceptionMessageHandler } from '$utils'
import { SharedSlice } from '../../../../../slice'
import { ILeaveType } from '$models'
import { LeaveTypesSlice } from '../slice'
import { leaveTypeService } from '$services'

interface AddLeaveTypeState {
  leaveType: ILeaveType | null
}

export interface AddLeaveTypeSlice extends AddLeaveTypeState {
  /**
   * Reset LeaveType Slice
   */
  resetAddLeaveTypeSlice: () => void

  /**
   * Update LeaveType
   * @param leaveType LeaveType to update
   * @param successMessage Success Message to display if the update was successful
   * @param errorMessage Error Message to display if the update has failed
   * @returns
   */
  addLeaveType: (
    leaveType: ILeaveType,
    successMessage?: string,
    errorMessage?: string
  ) => Promise<void>
}

const initialState: AddLeaveTypeState = {
  leaveType: null,
}

const createAddLeaveTypeSlice: StateCreator<
  AddLeaveTypeSlice & LeaveTypesSlice & SharedSlice,
  [],
  [],
  AddLeaveTypeSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetAddLeaveTypeSlice: () => set(initialState),

  // State API calls
  addLeaveType: async (
    leaveType: ILeaveType,
    successMessage?: string,
    errorMessage?: string
  ) => {
    try {
      set(() => ({ isLoading: true }))

      const addedLeaveType: ILeaveType = await leaveTypeService.add(leaveType)
      if (!addedLeaveType) {
        logger.error(`${errorMessage} - addedLeaveType doesn't exist`)
        enqueueLoadedSnackbar(errorMessage, 'error')
        return
      }

      set((state) => ({
        ...(addedLeaveType && {
          leaveTypes: [...state.leaveTypes, addedLeaveType],
        }),
      }))
      enqueueLoadedSnackbar(successMessage, 'success')
    } catch (error) {
      exceptionMessageHandler(error, errorMessage)
    }
  },
})

export default createAddLeaveTypeSlice
